import React, { Component } from 'react'
import { Col, Row, Carousel, Image, Container } from 'react-bootstrap';
import { Header } from './Header'
import EquipoMedico from '../Inicio/EquipoMedico.jpg';
import Medicamentos from '../Inicio/Medicamentos.jpg';
import Instrumental from '../Inicio/Instrumental.jpg';
import Calidad from '../Encabezado/Calidad.png'
import Tarjetas from '../Encabezado/Tarjetas.png'
import Marcas from '../Inicio/Marcas.jpg';
import { Footer } from './Footer'

export class EngHome extends Component {
    render() {
        return (
            /* 'min-height-100' asegura que el fondo claro cubra toda la pantalla */
            <div className="bg-light" style={{ minHeight: '100vh' }}>
                <Header />
                <Container>
                    <Carousel className="carousel slide carousel-fade fondo-ca shadow-sm">
                        <Carousel.Item>
                            <a href="/en/MedicalEquipment">
                                <Image
                                    className="d-block mx-auto img-fluid"
                                    width="64%"
                                    src={EquipoMedico}
                                    alt="Medical Equipment"
                                />
                            </a>
                            <Carousel.Caption>
                                <h3 className="text-light bg-dark d-inline-block px-2">Medical Equipment</h3>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                className="d-block mx-auto img-fluid"
                                width="80%"
                                src={Medicamentos}
                                alt="Medications"
                            />
                            <Carousel.Caption>
                                <h3 className="text-light bg-dark d-inline-block px-2">Medications</h3>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <a href="/en/Instrumental">
                                <img
                                    className="d-block mx-auto img-fluid"
                                    width="71%"
                                    src={Instrumental}
                                    alt="Surgical Instruments"
                                />
                            </a>
                            <Carousel.Caption>
                                <h3 className="text-light bg-dark d-inline-block px-2">Surgical Instruments</h3>
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>
                    <br />

                    <div className="fondo-texto p-4 rounded shadow-sm bg-white">
                        <h1 className="text-primary font-weight-bold">Welcome to Drycom!</h1>
                        <p className="text-justify mt-4 mb-4">
                            We are a company dedicated to the <strong>wholesale distribution</strong> of medical equipment, laboratory supplies, and medications, serving both the private sector and government institutions in Guatemala. We are pioneers in providing high-quality, trustworthy medical solutions. Our portfolio includes:
                        </p>

                        <Row>
                            <Col md={6}>
                                <ul className="list-unstyled">
                                    <li>✔ Bathroom safety equipment</li>
                                    <li>✔ Commercial medications</li>
                                    <li>✔ Diagnostic equipment</li>
                                    <li>✔ Disposable medical products</li>
                                    <li>✔ Cold chain equipment</li>
                                    <li>✔ Examination lamps</li>
                                    <li>✔ Medical furniture</li>
                                </ul>
                            </Col>

                            <Col md={6}>
                                <ul className="list-unstyled">
                                    <li>✔ Rehabilitation furniture</li>
                                    <li>✔ Generic medications</li>
                                    <li>✔ Stainless steel instrumentation</li>
                                    <li>✔ Medical supplies</li>
                                    <li>✔ Sutures</li>
                                    <li>✔ Weight and Height (Stadiometers)</li>
                                    <li>✔ Comprehensive health sector solutions</li>
                                </ul>
                            </Col>
                        </Row>
                        <p className="font-italic mt-3 border-top pt-2">Contact us for more information.</p>
                    </div>
                    <br />
                </Container>

                {/* Sección informativa con fondo blanco para contraste */}
                <div className="bg-white border-top border-bottom shadow-sm">
                    <Row className="mx-0">
                        <Col md={4} className="border-right border-light p-5 text-center">
                            <h2 className="h4 mb-4">Product Quality</h2>
                            <Image src={Calidad} width="80%" className="border-0 rounded" alt="Quality Assurance" />
                        </Col>

                        <Col md={4} className="p-5 bg-light d-flex align-items-center justify-content-center">
                            <div className="fb-page" 
                                 data-href="https://www.facebook.com/Drycom-Drogueria-Distribuidora-351242224953844/" 
                                 data-tabs="timeline" data-width="450" data-height="300" 
                                 data-small-header="true" data-adapt-container-width="true" 
                                 data-hide-cover="false" data-show-facepile="false">
                            </div>
                        </Col>

                        <Col md={4} className="border-left border-light p-5 text-center">
                            <h2 className="h4 mb-4">Our Brands</h2>
                            <div className="d-flex align-items-center justify-content-center h-100">
                                <Image src={Marcas} width="100%" alt="Trademarks" />
                            </div>
                        </Col>
                    </Row>
                </div>

                <Container className="py-5">
                    <Row className="justify-content-center">
                        <Col md={6} className="text-center">
                            <p className="small text-muted mb-2">We accept various payment methods</p>
                            <Image src={Tarjetas} width="60%" alt="Payment Methods" />
                        </Col>
                    </Row>
                </Container>
                
                <Footer />
            </div>
        )
    }
}